import script from "./SuccessPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SuccessPage.vue?vue&type=script&setup=true&lang=js"

import "./SuccessPage.vue?vue&type=style&index=0&id=5dc9610c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5dc9610c"]])

export default __exports__